const Index = ({
    handleClick
}:any) => {
    return (<>
     <div className="closebtn zoom_shrink"  onClick={handleClick}>
        <div className="close_icon zoom_shrink">
        </div>
    </div>
    </>)
};

export default Index;
